export default __webpack_public_path__ + "static/media/i116hp.92a77e7c.webp";